import styled, { css } from 'styled-components';
import { color, size } from './helpers/variables';
import { dynamicFontSize, fontFamilyHeading } from './helpers/mixins';

export const LinedHeadingContainer = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
  width: 100%;
  position: relative;
  display: flex;
  background-color: ${props => (props.bgColor ? props.bgColor : 'inherit')};
  justify-content: center;
  align-items: center;
  z-index: 1;

  &:before {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    position: absolute;
    top: 50%;
    left: 0;
    background-color: ${color.grey};
  }

  ${props =>
    props.adjustToScrollMargin &&
    css`
      margin-top: 45px;
      margin-bottom: 20px;
    `};
  
  ${props => props.noMargin && css`
    margin-top: 0 !important;
  `};
  
  ${props => props.noBottomMargin && css`
    margin-bottom: 0 !important;
  `};
  
  @media screen and (min-width: ${size.xLarge}px) {
    margin-top: 65px;
  }
`;

export const LinedHeadingText = styled.p`
  ${fontFamilyHeading};
  ${dynamicFontSize(14, 20, size.small, size.large)};
  ${props =>
    !!props.smallestFontSizeBound &&
    css`
      ${dynamicFontSize(props.smallestFontSizeBound, 35, size.small, size.large)};
    `};

  font-weight: normal;
  line-height: 1.45;
  letter-spacing: 2px;
  text-align: center;
  color: ${props => (props.color ? props.color : color.black)};
  background-color: inherit;
  text-transform: uppercase;
  display: inline-block;
  position: relative;
  padding: 0 0.5rem;
  margin: 0 0.5rem;
`;



// WEBPACK FOOTER //
// ./src/styles/LinedHeading.js